











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('CurrentUserDashboardsQuery')
    
    export class CurrentUserDashboardsQuery implements IPaginatedQuery {
        constructor( filterByName?: string, filterById?: number ) {
            
                this.filterByName = filterByName;
            
                this.filterById = filterById;
            
        }

        
            
            public filterByName?: string;
        
            
            public filterById?: number;
        

        

        
            /**
            *   Sets the direction of the pager.
            */
            public direction: SearchDirection = SearchDirection.Next;

            /**
            *   Sets the number of items per page.
            */
            public perPage: number = 10;
        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: CurrentUserDashboardsQuery ) {
                return new QueryExecutor<CurrentUserDashboardsQuery, CurrentUserDashboardsQueryResult>(CurrentUserDashboardsQueryResult, query);
            }

            

            
                /**
                * Returns an instance of a paginated QueryExecutor for this query.
                */
                public static getPaginatedExecutor( query?: CurrentUserDashboardsQuery ) {
                    return new PaginatedQueryExecutor<CurrentUserDashboardsQuery, CurrentUserDashboardsQueryResult>(CurrentUserDashboardsQueryResult, query);
                }

                
            
        
    }

    

    
        /**
        * The result model for CurrentUserDashboardsQuery.
        */
        export class CurrentUserDashboardsQueryResult {
            
                
                 dashboardId: number;
            
                
                 name: string;
            
                
                @Transform((val) => val ? moment.utc(val).toDate() : val ) createDate: Date;
            
                
                 dashboardGrantLevel: number;
            
                
                 nbSensor: number;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace CurrentUserDashboardsQuery.ExtraneousTypes {
        

        
    }

